import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  AirMeasurementGraphResponse,
  AirQualityStatisticResponse,
  AirSensorType,
} from '../types/air-stats.types';

export const fetchAirQualityStatistic = (
  sensorType: AirSensorType,
  params = ''
): Promise<AirQualityStatisticResponse> => {
  const fullParams = params
    ? `sensor_type=${sensorType}&${params}`
    : `sensor_type=${sensorType}`;
  const url = `${URLS.BACK_DSH}${APIS.airQualityStatistic(fullParams)}`;
  return request.get<AirQualityStatisticResponse>(url);
};

export const fetchAirQualityMeasurementGraph = (
  sensorType: AirSensorType,
  params = ''
): Promise<AirMeasurementGraphResponse> => {
  const fullParams = params
    ? `sensor_type=${sensorType}&${params}`
    : `sensor_type=${sensorType}`;
  const url = `${URLS.BACK_DSH}${APIS.airQualityMeasurementGraph(fullParams)}`;
  return request.get<AirMeasurementGraphResponse>(url);
};
